import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerCustomIcons } from '@icons';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import relativeTime from 'dayjs/plugin/relativeTime';

registerCustomIcons();
// dayjs
dayjs.locale('pt-br');
dayjs.extend(relativeTime);

bootstrapApplication(AppComponent, appConfig)
    .catch((err: Error) => console.error(err));
